import React from 'react';

interface IProps {
  children: any;
}

export const BooleanLookupWrapper = (props: IProps): JSX.Element => {
  return <>{props.children}</>;
};
